import axios from "axios";

// Setup : make sure that you have install alpinejs and import them to resources/js/bootstrap
// import Alpine from 'alpinejs'
// window.Alpine = Alpine

// Move these code to resources/js/bootstrap
// import editResource from "./resources/edit.js";
// Alpine.data('editResource',editResource)

// Alpine.start()

export default (rate) => ({
    amount_ttc: null,
    formatted_amount_ttc: null,

    amount_ht: null,
    formatted_amount_ht: null,
    amount_rate: null,
    formatted_amount_rate: null,
    rate: rate,
    quantity: 1,
    total_ttc: null,

    updateValues() {
        this.amount_ht = Math.round((this.amount_ttc / (1 + this.rate / 100)) * this.quantity);
        this.amount_rate = Math.round((this.amount_ttc - (this.amount_ttc / (1 + this.rate / 100))) * this.quantity);

        this.total_ttc = this.amount_ttc * this.quantity;

        this.format();
    },

    format() {
        if (this.amount_ttc) {
            this.formatted_amount_ttc = _format(this.total_ttc)
        }

        if (this.amount_ht) {
            this.formatted_amount_ht = _format(this.amount_ht)
        }

        if (this.amount_rate) {
            this.formatted_amount_rate = _format(this.amount_rate)
        }
    }

})

function _format(data) {
    return new Intl.NumberFormat('fr-FR').format(data);
}
